import React, { useState, useEffect } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { Link, useNavigate } from "react-router-dom";
import { getProfile, updateProfile } from "../../core/api/auth";
import { useSelector,useDispatch } from "react-redux";  

const Profile = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const reduxProfile = useSelector((state) => state.profile);
  console.log("Profile from Redux store:", reduxProfile);
  const [profile, setProfile] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    username: "",
  });
  const [selectedImage, setSelectedImage] = useState(null);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        setProfile(reduxProfile);
      } catch (err) {
        setError("Failed to load user profile");
      }
    };

    fetchProfile();
  }, [reduxProfile]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedImage(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("first_name", profile.first_name);
    formData.append("last_name", profile.last_name);
    formData.append("email", profile.email);
    formData.append("phone_number", profile.phone_number);
    formData.append("username", profile.username);
    // if (selectedImage) formData.append("profile_image", selectedImage);

    try {
      await updateProfile(formData);
      setSuccessMessage("Profile updated successfully");
      await dispatch(getProfile());
    } catch (err) {
      setError("Failed to update profile", err);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Profile</h4>
            <h6>User Profile</h6>
          </div>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}
        {successMessage && (
          <div className="alert alert-success">{successMessage}</div>
        )}

        <div className="card">
          <div className="card-body">
            <div className="profile-set">
              <div className="profile-top">
                <div className="profile-content">
                  <div className="profile-contentimg">
                    <ImageWithBasePath
                      src={
                        selectedImage
                          ? URL.createObjectURL(selectedImage)
                          : "assets/img/profile.png"
                      }
                      alt="img"
                    />
                    <div className="profileupload">
                      <input type="file" onChange={handleImageChange} />
                      <Link to="#">
                        <ImageWithBasePath
                          src="assets/img/icons/edit-set.svg"
                          alt="img"
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="profile-contentname">
                    <h2>
                      {profile.first_name} {profile.last_name}
                    </h2>
                    <h4>Update Your Photo and Personal Details.</h4>
                  </div>
                </div>
              </div>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label className="form-label">First Name</label>
                    <input
                      type="text"
                      name="first_name"
                      className="form-control"
                      value={profile.first_name}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label className="form-label">Last Name</label>
                    <input
                      type="text"
                      name="last_name"
                      className="form-control"
                      value={profile.last_name}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label>Email</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      value={profile.email}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label className="form-label">Phone</label>
                    <input
                      type="text"
                      name="phone_number"
                      className="form-control"
                      value={profile.phone_number}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label className="form-label">Username</label>
                    <input
                      type="text"
                      name="username"
                      className="form-control"
                      value={profile.username}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                {/* <div className="col-lg-6 col-sm-12">
                  <div className="input-blocks">
                    <label className="form-label">Password</label>
                    <div className="pass-group">
                      <input
                        type={isPasswordVisible ? "text" : "password"}
                        name="password"
                        className="pass-input form-control"
                        onChange={handleInputChange}
                      />
                      <span
                        className={`fas toggle-password ${isPasswordVisible ? "fa-eye" : "fa-eye-slash"}`}
                        onClick={togglePasswordVisibility}
                      ></span>
                    </div>
                  </div>
                </div> */}
                <div className="col-12">
                  <button type="submit" className="btn btn-submit me-2">
                    Submit
                  </button>
                  <Link
                    className="btn btn-cancel"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    Cancel
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
